import { useQuery } from '@tanstack/react-query'
import { healthApi } from '@/lib/api'

export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: async () => {
      const raw = await healthApi.get()
      const isOk = raw.status === 'ok'
      return {
        status: (isOk ? 'healthy' : 'degraded') as 'healthy' | 'degraded' | 'down',
        checkedAt: raw.timestamp,
        uptime: 0,
        services: [
          {
            name: 'api',
            status: 'healthy' as 'healthy' | 'degraded' | 'down',
            responseTimeMs: 0,
            checkedAt: raw.timestamp,
            detail: 'v' + raw.version,
          },
          {
            name: 'database',
            status: (raw.database === 'connected' ? 'healthy' : 'down') as 'healthy' | 'degraded' | 'down',
            responseTimeMs: 0,
            checkedAt: raw.timestamp,
            detail: raw.database,
          },
        ],
      }
    },
    staleTime: 30_000,
  })
}
